export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_7-e13c9fa835dd8cf78d43f3a10c3d5c66.svg";